



















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import {Location} from "vue-router"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsNavigatorItemGroup extends Vue {
    @Prop({default: false, type: Boolean}) canAdd!: boolean;
    @Prop({default: null}) addTo!: Location|null;
    @Prop({default: ''}) title!: string;
}
